import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { shallow } from "zustand/shallow";
import { Panels, } from "../../GenericViewerState/SharedState";
import { useEffect } from "react";
import { rightPanel } from "../panelDimensions";
import { Box, Fade, useTheme } from "@mui/material";
import { LLMChat } from "../../LLMChat/LLMChat";
import vwToPx from "../../utils/vwToPixels";
import { VerticalDragHandler } from "./DragHandlers/VerticalDragHandler";
import { userAuthStore } from "../../Authentication/userAuthState";
import { ChatAuthenticate } from "../../LLMChat/ChatAuthenticate";
export const ChatPanel = ({ NAPGenericStore, vss, molstar, pyodide, pyodideReady, }) => {
    const { width, datavizWidth, setWidth, setActivePanels, activePanels, isResizing, setIsResizing, } = NAPGenericStore((state) => ({
        width: state.chatPanelWidth,
        datavizWidth: state._activePanels.plots ? state.dataVizPanelWidth : "0px",
        setWidth: state.setChatPanelWidth,
        setActivePanels: state.setActivePanels,
        activePanels: state._activePanels,
        isResizing: state.isResizing,
        setIsResizing: state.setIsResizing,
    }), shallow);
    const hideChat = () => {
        setActivePanels(Object.assign(Object.assign({}, activePanels), { [Panels.chat]: false }));
    };
    const theme = useTheme();
    const backgroundColor = "#383838";
    const backgroundColorWithOpacity = "#38383880";
    const textColor = theme.palette.getContrastText(backgroundColor);
    // const maxHeight = activePanels.console
    //   ? `calc(100vh - ${bottomPanel.height} + 1.2em)`
    //   : undefined;
    const rightPanelDimensions = Object.assign(Object.assign({}, rightPanel), { 
        // p: (theme: Theme) => `calc(${theme.spacing(1)})`,
        // pl: "10px",
        // maxHeight: maxHeight,
        width: width, bgcolor: backgroundColor });
    useEffect(() => {
        if (pyodideReady) {
            const mediaQuery4 = window.matchMedia("(min-width: 1400px)");
            const mediaQuery3 = window.matchMedia("(min-width: 1200px)");
            const mediaQuery2 = window.matchMedia("(min-width: 1100px)");
            const mediaQuery1 = window.matchMedia("(min-width: 900px)"); //768px
            if (mediaQuery4.matches) {
                setActivePanels(Object.assign(Object.assign({}, activePanels), { [Panels.chat]: true }));
            }
            else if (mediaQuery3.matches) {
                setWidth("350px");
                setActivePanels(Object.assign(Object.assign({}, activePanels), { [Panels.chat]: true }));
            }
            else if (mediaQuery2.matches) {
                setWidth("315px");
                setActivePanels(Object.assign(Object.assign({}, activePanels), { [Panels.chat]: true }));
            }
            else if (mediaQuery1.matches) {
                setWidth("215px");
                setActivePanels(Object.assign(Object.assign({}, activePanels), { [Panels.chat]: true }));
            }
        }
    }, [pyodideReady]);
    const [userInfo] = userAuthStore((state) => [state.userInfo], shallow);
    //@ts-ignore
    const isElectron = !!window.electron;
    const isAuthenticated = userInfo || isElectron;
    const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId;
    return (_jsx(_Fragment, { children: _jsx(Fade, Object.assign({ in: activePanels.chat, style: { zIndex: 4 }, timeout: 1000 }, { children: _jsxs(Box, Object.assign({ sx: { userSelect: isResizing ? "none" : "auto" } }, { children: [_jsx(VerticalDragHandler, { onSetWidthCb: (w) => {
                            setWidth(`${w}px`);
                        }, onSetIsResizingCb: (val) => {
                            setIsResizing(val);
                        }, iconColor: textColor, backgroundColor: backgroundColor, leftSpaceOcuppied: vwToPx(datavizWidth), initialWidth: vwToPx(width) }), _jsxs(Box, Object.assign({ id: "chat-entrypoint", sx: rightPanelDimensions }, { children: [_jsx(LLMChat, { textColor: textColor, vss: vss, molstar: molstar, pyodide: pyodide, hideChat: hideChat, disabled: !isAuthenticated, userId: userId || "" }), !isAuthenticated && (_jsx(ChatAuthenticate, { backgroundColor: backgroundColorWithOpacity, textColor: textColor }))] }))] })) })) }));
};
